import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function animationFooter() {

  /* ====================================
  # フッター光の点エフェクト初期化
  ==================================== */
  const initFooterLightAnimation = () => {
    const bgElements = [
      { element: document.querySelector('.l-footer__bg01'), type: 'bg01' },
      { element: document.querySelector('.l-footer__bg02'), type: 'bg02' }
    ];

    bgElements.forEach(({ element, type }) => {
      if (element) {
        addFooterLightDots(element, type);
      }
    });
  };

  /* ====================================
  # フッター光の点エフェクト
  ==================================== */
  const addFooterLightDots = (container, bgType) => {
    const svgElement = container.querySelector('svg');
    if (!svgElement) return;

    // SVG内のpath要素を探す
    const pathElements = svgElement.querySelectorAll('path[stroke]') || svgElement.querySelectorAll('path');
    
    if (pathElements.length > 0) {
      createFooterLightDot(pathElements[0], container, bgType);
    }
  };

  const createFooterLightDot = (pathElement, container, bgType) => {
    // 光の点要素を作成
    const lightDot = document.createElement('div');
    lightDot.className = `footer-light-dot footer-light-dot--${bgType}`;

    // コンテナに追加
    container.appendChild(lightDot);

    // パスの長さを取得
    const pathLength = pathElement.getTotalLength();
    let currentDistance = 0;
    let isAnimating = false;

    // 移動設定
    const animationConfig = {
      speed: bgType === 'bg01' ? 6 : 4,
      direction: bgType === 'bg01' ? 1 : -1
    };

    // アニメーションループ
    const animateFooterLightDot = () => {
      if (!isAnimating) return;
      
      // パス上の現在位置を取得
      const point = pathElement.getPointAtLength(currentDistance);
      const svgCTM = pathElement.getScreenCTM();
      
      if (svgCTM) {
        // SVGの変換行列を使って正確な画面座標を取得
        const screenPoint = point.matrixTransform(svgCTM);
        const containerRect = container.getBoundingClientRect();
        
        lightDot.style.left = (screenPoint.x - containerRect.left) + 'px';
        lightDot.style.top = (screenPoint.y - containerRect.top) + 'px';
      }

      // 次の位置に移動
      currentDistance += animationConfig.speed * animationConfig.direction;
      
      if (currentDistance > pathLength) {
        currentDistance = 0;
      } else if (currentDistance < 0) {
        currentDistance = pathLength;
      }

      requestAnimationFrame(animateFooterLightDot);
    };

    // スクロールトリガーでアニメーション開始
    ScrollTrigger.create({
      trigger: container,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        isAnimating = true;
        animateFooterLightDot();
      },
      onLeave: () => {
        isAnimating = false;
      },
      onEnterBack: () => {
        isAnimating = true;
        animateFooterLightDot();
      },
      onLeaveBack: () => {
        isAnimating = false;
      }
    });
  };

  // 初期化実行
  initFooterLightAnimation();
} 